<template>
  <header class="siteHeader">
    <!-- Content -->
    <div class="siteHeader-content">
      <div class="headerLogo" v-scroll-to="{}">
        <a href="http://alpha-stella.com">
          <img src="../assets/α-Stella_Logo-S.png" alt="">
        </a>
        <div class="siteHeader-content-menuBtn" @click="visibleMenu=!visibleMenu">
          <i class="fa fa-bars fa-2x fa-fw" aria-hidden="true"></i>
          <div class="siteHeader-content-menuBtn-menu" v-if="visibleMenu">
            <site-menu v-bind:useAutoHideForMobile='false'/>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import SiteMenu from './SiteMenu'
export default {
  components: { SiteMenu },
  data () {
    return {
      show: false,
      visibleMenu: false
    }
  }
}
</script>

<style scoped lang="scss">
@import './../styles/definitions.scss';
.siteHeader {
  background-color: $kHeaderColorMain;
  background-image: url(../assets/alpha-stella_header_bg.png);
  border-bottom: 2px solid #ffffff5d;
  margin: 0 0;
  padding: 0px 0 0px;
  z-index: $kZIndexHeader;
  &-content{
    text-align: left;
    .headerLogo{
        padding: 5px 0px 0px 10px;
    }
    &-menuBtn {
      display: none;
      transition: 0.2s ease-out;
      @media (max-width: $MobileWidth) {
        position: fixed;
        margin: 5px;
        display: block;
        top: 0;
        right: 0;
        color: rgb(241, 242, 255);
        background: rgb(59, 64, 136);
        z-index: $kZindexMenuButton;
        &:hover {
          background: rgb(107, 113, 190);
        }
        &-menu {
          display: block;
          position: fixed;
          right: $MenuWidth;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SiteHeader.vue